import type { ProductOptionData } from "@features/products/helpers/variantHelpers";
import { createAction } from "@redux/actions/actionCreators";

const [useSetProductOptions, setProductOptions] = createAction<{
  productUuid: string;
  options: ProductOptionData[];
}>("product/setOptions");

export default useSetProductOptions;
export { setProductOptions };
